import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.Screening.title',
    defaultMessage: 'Screening',
  },
  submitScreening: {
    id: 'App.Screening.submitScreening',
    defaultMessage: 'Submit Screening',
  },
  finalScreeningStatus: {
    id: 'App.Screening.finalScreeningStatus',
    defaultMessage: 'Final Screening Status',
  },
  reasonForDecision: {
    id: 'App.Screening.reasonForDecision',
    defaultMessage: 'Reason for Decision',
  },
  credit: {
    id: 'App.Screening.credit',
    defaultMessage: 'Credit',
  },
  criminal: {
    id: 'App.Screening.criminal',
    defaultMessage: 'Criminal',
  },
  evictions: {
    id: 'App.Screening.evictions',
    defaultMessage: 'Evictions',
  },
  missingRequiredFields: {
    id: 'App.Screening.missingRequiredFields',
    defaultMessage: 'Invalid or Missing Required Information',
  },
  applicantsWithMissingFields: {
    id: 'App.Screening.applicantsWithMissingFields',
    defaultMessage: 'Applicants Needing Review',
  },
  notReady: {
    id: 'App.Screening.notReady',
    defaultMessage: 'Not ready',
  },
  notStarted: {
    id: 'App.Screening.notStarted',
    defaultMessage: 'Not started',
  },
  details: {
    id: 'App.Screening.details',
    defaultMessage: 'Details',
  },
  submitScreeningModalTitle: {
    id: 'App.Screening.submitScreeningModalTitle',
    defaultMessage: 'Application Screening',
  },
  estimatedMonthlyRentAmount: {
    id: 'App.Screening.estimatedMonthlyRentAmount',
    defaultMessage: 'Estimated Monthly Rent Amount',
  },
  estimatedMonthlyRentAmountError: {
    id: 'App.Screening.estimatedMonthlyRentAmountError',
    defaultMessage: 'Amount must be between $1 and $25,000',
  },
  cancel: {
    id: 'App.Screening.cancel',
    defaultMessage: 'Cancel',
  },
  confirmAndSubmit: {
    id: 'App.Screening.confirmAndSubmit',
    defaultMessage: 'Confirm & Submit',
  },
  submitScreeningModalInfo: {
    id: 'App.Screening.submitScreeningModalInfo',
    defaultMessage:
      "Screenings will use the monthly rent amount entered above to ensure the household's financial qualifications " +
      "align with the unit's rent. If you change the rent amount, " +
      'submitting a new screening will re-run all screenings ' +
      'based on the updated amount. Once all results are returned, you can make a final decision.',
  },
  screeningSubmitted: {
    id: 'App.Screening.screeningSubmitted',
    defaultMessage: 'Screening Submitted',
  },
  success: {
    id: 'App.Screening.success',
    defaultMessage: 'Success',
  },
  error: {
    id: 'App.Screening.error',
    defaultMessage: 'Error',
  },
  required: {
    id: 'App.Screening.required',
    defaultMessage: 'Required',
  },
  choose: {
    id: 'App.Screening.choose',
    defaultMessage: 'Choose',
  },
  approved: {
    id: 'App.Screening.approved',
    defaultMessage: 'Approved',
  },
  approvedWithConditions: {
    id: 'App.Screening.approvedWithConditions',
    defaultMessage: 'Approved with Conditions',
  },
  declined: {
    id: 'App.Screening.declined',
    defaultMessage: 'Declined',
  },
  saveFinalDecision: {
    id: 'App.Screening.saveFinalDecision',
    defaultMessage: 'Save Final Decision',
  },
  screeningSubmittedOn: {
    id: 'App.Screening.screeningSubmittedOn',
    defaultMessage: 'Screening submitted on',
  },
  by: {
    id: 'App.Screening.by',
    defaultMessage: 'by',
  },
  failedToSubmitScreening: {
    id: 'App.Screening.failedToSubmitScreening',
    defaultMessage: 'Failed to submit screening',
  },
  edit: {
    id: 'App.Screening.edit',
    defaultMessage: 'Edit',
  },
  finalDecisionSaved: {
    id: 'App.Screening.finalDecisionSaved',
    defaultMessage: 'Final Decision Saved',
  },
  errorSavingFinalDecision: {
    id: 'App.Screening.errorSavingFinalDecision',
    defaultMessage: 'Error saving final decision',
  },
  madeOn: {
    id: 'App.Screening.madeOn',
    defaultMessage: 'made on',
  },
  createAdverseActionLetter: {
    id: 'App.Screening.createAdversonActionLetter',
    defaultMessage: 'Create Adverse Action Letter',
  },
  finalDecisionPermissionRequiredTooltip: {
    id: 'App.Screening.finalDecisionPermissionRequiredTooltip',
    defaultMessage: 'Permission Required: Screening - Can make final decision',
  },
  recommendedScreeningResult: {
    id: 'App.Screening.recommendedScreeningResult',
    defaultMessage: 'Screening Result Recommendation',
  },
  noAdditionalDetailsFound: {
    id: 'App.Screening.noAdditionalDetailsFound',
    defaultMessage:
      'No additional details were provided with this screening result.',
  },
  notEnoughInformation: {
    id: 'App.Screening.notEnoughInformation',
    defaultMessage: 'Not Enough Information',
  },
  recommendedOverallApplicationResult: {
    id: 'App.Screening.recommendedOverallApplicationResult',
    defaultMessage: 'Overall Screening Recommendation',
  },
  whyThisRecommendation: {
    id: 'App.Screening.whyThisRecommendation',
    defaultMessage: 'Why this recommendation?',
  },
  canceled: {
    id: 'App.Screening.canceled',
    defaultMessage: 'Canceled',
  },
  canceledDetail: {
    id: 'App.Screening.canceledDetail',
    defaultMessage:
      'Application status was changed to Canceled before this screening was processed.',
  },
  deniedDetail: {
    id: 'App.Screening.deniedDetail',
    defaultMessage:
      'Application status was changed to Denied before this screening was processed.',
  },
  screeningStoppedDefaultDetail: {
    id: 'App.Screening.screeningStoppedDefaultDetail',
    defaultMessage:
      'Screening was automatically stopped because one or more results failed or encountered an error.',
  },
  rentAmount: {
    id: 'App.Screening.rentAmount',
    defaultMessage: 'Rent amount must be between $0 and $25,000.',
  },
  employmentIncome: {
    id: 'App.Screening.employmentIncome',
    defaultMessage: 'Employment income must be greater than $0.',
  },
  invalidAddress: {
    id: 'App.Screening.invalidAddress',
    defaultMessage: 'One of the street addresses does not appear valid.',
  },
  invalidCity: {
    id: 'App.Screening.invalidCity',
    defaultMessage: 'One of the cities does not appear valid.',
  },
  invalidState: {
    id: 'App.Screening.invalidState',
    defaultMessage:
      'One of the states (2-letter abbreviation) does not appear valid.',
  },
  invalidPostalCode: {
    id: 'App.Screening.invalidPostalCode',
    defaultMessage: 'One of the address postal codes does not appear valid.',
  },
  generalError: {
    id: 'App.Screening.generalError',
    defaultMessage:
      'Something went wrong. Please try again. If the problem continues, reach out to your admin.',
  },
  reviewAndUpdate: {
    id: 'App.Screening.reviewAndUpdate',
    defaultMessage: 'Please review and update any values before trying again.',
  },
  criminalNotStartedAfterDecline: {
    id: 'App.Screening.criminalNotStartedAfterDecline',
    defaultMessage:
      'Criminal screening was not run because the screening was stopped.',
  },
  criminalReportAwaiting: {
    id: 'App.Screening.criminalReportAwaiting',
    defaultMessage: 'Criminal report requested. Awaiting results.',
  },
  runCriminalScreeningTitle: {
    id: 'App.Screening.runCriminalScreeningTitle',
    defaultMessage: 'Run Criminal Screening?',
  },
  runCriminalScreeningBody1: {
    id: 'App.Screening.runCriminalScreeningBody1',
    defaultMessage:
      'Are you sure you want to proceed with criminal screening for this applicant?',
  },
  runCriminalScreeningBody2: {
    id: 'App.Screening.runCriminalScreeningBody2',
    defaultMessage:
      'Once initiated, the criminal screening status will change to In Progress, ' +
      'and results will update automatically as they become available.',
  },
  confirm: {
    id: 'App.Screening.confirm',
    defaultMessage: 'Confirm',
  },
  reasonForDecline: {
    id: 'App.Screening.reasonForDecline',
    defaultMessage: 'Reason for Decline',
  },
  reasonForDeclinePlaceholder: {
    id: 'App.Screening.reasonForDeclinePlaceholder',
    defaultMessage: 'Enter the reason for declining this applicant...',
  },
  reasonForDeclineHelp: {
    id: 'App.Screening.reasonForDeclineHelp',
    defaultMessage:
      'This reason is shown as the Reason for Decision on the final screening ' +
      'status. Please provide an accurate, specific reason for the decision.',
  },
  confirmDecline: {
    id: 'App.Screening.confirmDecline',
    defaultMessage: 'Confirm Decline',
  },
  applicantDeclinedWithoutCriminalScreening: {
    id: 'App.Screening.applicantDeclinedWithoutCriminalScreening',
    defaultMessage: 'The applicant was declined without criminal screening.',
  },
  phasedScreeningAlreadyResolved: {
    id: 'App.Screening.phasedScreeningAlreadyResolved',
    defaultMessage: 'This screening was already run or declined.',
  },
  failedToDeclineWithoutCriminalScreening: {
    id: 'App.Screening.failedToDeclineWithoutCriminalScreening',
    defaultMessage: 'Failed to decline the applicant. Please try again.',
  },
  criminalReportRequested: {
    id: 'App.Screening.criminalReportRequested',
    defaultMessage: 'The criminal report was requested.',
  },
  failedToRequestCriminalReport: {
    id: 'App.Screening.failedToRequestCriminalReport',
    defaultMessage: 'Failed to request the criminal report. Please try again.',
  },
  info: {
    id: 'App.Screening.info',
    defaultMessage: 'Info',
  },
  stopScreeningTitle: {
    id: 'App.Screening.stopScreeningTitle',
    defaultMessage: 'Stop Screening?',
  },
  stopScreeningBody: {
    id: 'App.Screening.stopScreeningBody',
    defaultMessage:
      'You’re choosing to stop the screening before it is complete. ' +
      'This will automatically decline the screening for this household.',
  },
  menuResubmitScreening: {
    id: 'App.Screening.menuResubmitScreening',
    defaultMessage: 'Resubmit Screening',
  },
  menuContinueScreening: {
    id: 'App.Screening.menuContinueScreening',
    defaultMessage: 'Continue Screening',
  },
  menuStopScreening: {
    id: 'App.Screening.menuStopScreening',
    defaultMessage: 'Stop Screening',
  },
  menuReasonInProgress: {
    id: 'App.Screening.menuReasonInProgress',
    defaultMessage: 'Not available while the screening is in progress.',
  },
  menuReasonWaitingForTransUnion: {
    id: 'App.Screening.menuReasonWaitingForTransUnion',
    defaultMessage: 'Waiting for TransUnion credit and eviction results.',
  },
  menuReasonNoPermission: {
    id: 'App.Screening.menuReasonNoPermission',
    defaultMessage: 'You do not have permission to perform this action.',
  },
  menuReasonCriminalRequested: {
    id: 'App.Screening.menuReasonCriminalRequested',
    defaultMessage: 'Criminal report requested. Awaiting results.',
  },
  menuReasonCriminalRunning: {
    id: 'App.Screening.menuReasonCriminalRunning',
    defaultMessage: 'The criminal report is already running.',
  },
  menuReasonComplete: {
    id: 'App.Screening.menuReasonComplete',
    defaultMessage: 'The screening is complete.',
  },
  menuReasonStopped: {
    id: 'App.Screening.menuReasonStopped',
    defaultMessage: 'The screening was stopped.',
  },
  decisionNeeded: {
    id: 'App.Screening.decisionNeeded',
    defaultMessage: 'Decision needed',
  },
  decisionNeededInfo: {
    id: 'App.Screening.decisionNeededInfo',
    defaultMessage:
      'Click the Submit Screening button to continue with the screening process.',
  },
});

export default messages;
